<form [formGroup]="form">
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutGap="10px">
      <div fxFlex="calc(50%-10px)">
        <mat-form-field class="full-width">
          <mat-label>{{ 'crm.contact.name'|translate }}</mat-label>
          <input data-ci="name" matInput placeholder="{{'crm.contact.name'|translate}}" formControlName="name">

          <mat-error *ngIf="form.get('name').invalid && form.get('name').touched"
            [flexFormControlError]="form.get('name')"
            [customMessages]="{
              'required': 'crm.contact.validators.name_cannot_blank'|translate
            }"></mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="calc(50%-10px)">
        <mat-form-field class="full-width">
          <mat-label>{{ 'crm.contact.phone'|translate }}</mat-label>
          <input data-ci="phone" matInput placeholder="{{'crm.contact.phone'|translate}}" formControlName="phoneNumber">

          <mat-error [flexFormControlError]="form.get('phoneNumber')"
            *ngIf="form.get('phoneNumber').invalid && form.get('phoneNumber').touched"></mat-error>

        </mat-form-field>
      </div>
    </div>

    <div fxFlex fxLayout="column">
      <mat-form-field>
        <mat-label>{{ 'crm.contact.email'|translate }}</mat-label>
        <input data-ci="email" matInput type="email" placeholder="{{'crm.contact.email'|translate}}"
          formControlName="email">

        <mat-error *ngIf="form.get('email').invalid && form.get('email').touched"
          [flexFormControlError]="form.get('email')"
          [customMessages]="{
            'wrongEmail': 'public.message.email_invalid'|translate
          }"></mat-error>

      </mat-form-field>
    </div>
  </div>
</form>
